<template>
	<div>

		<select v-model="type" class="form-control mb-1">
			<option v-for="option in allowedOptions" :value="option">{{ _lang(option,'input') }}</option>
		</select>

		<input v-if="type=='external'" type="url" class="form-control" v-model="handler" @change="input()">

		<select v-if="type=='internal'" class="form-control" v-model="handler" @change="input">
			<optgroup :label="_lang('Pages')">
				<option v-for="page in pages" :value="page.slug">{{ page.name }}</option>
			</optgroup>
			<optgroup label="Modal">
				<option v-for="modal in modals">{{modal}}</option>
			</optgroup>
		</select>

		<div v-if="type=='file'">
			<input type="file" class="form-control mb-2" @change="onFileChange">
			<input :value="handler" class="form-control" readonly>
		</div>

	</div>
</template>

<script>
	import axios from 'axios';
export default {
  props: ['value','config'],

  data(){
    return {
      type:'internal',
      handler:'',
      options:[ 'internal', 'external', 'file' ]
    }
  },
  computed:{
    pages(){
        return this.$store.getters.pages.map(page=>{
            return {
                id:page.id,
                uid:page.uid,
                slug:page.slug,
                name:page.name,
            };
        });
    },
    modals(){
        var modals = window.iframeDom.document.body.querySelectorAll('.modal');
        var ids = [];
        for(var i = 0;i<modals.length;i++){
            ids.push('#modal-'+modals[i].parentNode.parentNode.className.match(/block-(block\d+)/).pop());
        }
        return ids;
    },
    allowedOptions(){
      if(!this.allowed) return this.options;
      return this.options.filter(item=>{
        return this.allowed.includes(item);
      })
    },
    allowed(){
      if(!this.config.vars || !this.config.vars.allowed) return false;
      return this.config.vars.allowed;
    }
  },
  mounted(){
    if(!this.value) return;
    this.handler = this.value;
    var match = this.value.match(new RegExp(process.env.VUE_APP_BASEURL+'/uploads'));
    if(match) return  this.type = 'file';

    var match = this.value.match(/^http/);
    if(match){
      this.type = 'external';
    }
  },
  methods:{

		onFileChange(event,field){
				var files = event.target.files || event.dataTransfer.files;

				var file = files[0];
				if(!file) return;
				event.target.value='';

				var reader = new FileReader();
				reader.onload = (e) => {
						var base64 =  e.target.result;
						var data = {
								name:file.name,
								content:base64
						}

						axios.post('/api/upload',data).then((response)=> {
								this.handler = response.data;
								this.input();
						}).catch((error) =>  {
								console.error(error);
								if(error.response) alert(error.response.data);
						})

				}
				reader.readAsDataURL(file);
		},
    input(){
        /*
        var newval = this.handler+this.unit;
        if(!this.unit) newval = '';
        if(this.unit=='auto') newval = 'auto';
        */
        var newval = this.handler;
        console.log('input width new val', newval)
        this.$emit('change',newval);
    },

  }

}
</script>
